import Base from '@studiometa/js-toolkit';
import gsap from 'gsap';

/**
 * Loader Class
 */
export default class Loader extends Base {
  /**
   * Component config
   */
  get config() {
    return {
      name: 'Loader',
    };
  }

  /**
   * Mounted hook
   */
  mounted() {
    gsap.set(this.$el, { y: 0 });
    const tl = gsap.timeline({
      onComplete: () => {
        this.$el.style.transform = '';
      },
    });

    tl.to(this.$refs.clip, 0.8, {
      width: '120%',
      ease: 'circ.in',
      delay: 0.4,
    });

    tl.to(this.$el, {
      y: '100%',
      duration: 0.9,
      ease: 'power3.inOut',
    });
  }

  /**
   * Hide Loader
   */
  animateIn(done) {
    gsap.to(this.$el, {
      y: '100%',
      duration: 0.6,
      ease: 'power3.inOut',
      onComplete: () => {
        this.$el.style.transform = '';
        if (done) {
          done();
        }
      },
    });
  }

  /**
   * Show loader
   */
  animateOut(done) {
    gsap.fromTo(
      this.$refs.clip,
      0.8,
      { width: 0 },
      {
        width: '120%',
        ease: 'circ.in',
        delay: 0.4,
      }
    );
    gsap.fromTo(
      this.$el,
      {
        y: '-100%',
      },
      {
        y: '0',
        duration: 0.6,
        ease: 'power3.inOut',
        onComplete: () => {
          setTimeout(() => {
            if (done) {
              done();
            }
          }, 600);
        },
      }
    );
  }
}
